module.exports = __webpack_public_path__ + "img/wwzs.ad1f9d9.png";